module.exports = __webpack_public_path__ + "static/media/Serenity soffa 4sits Sense 4001 beige detalj 2024 1.a73d0170.jpg";